import React from "react"
import Header from "./component/Head/Header"
import Features from "./component/Features/Features"
import Home from "./component/Hero/Home"
import Portfolio from "./component/Portfolio/Portfolio"
import Resume from "./component/Resume/Resume"
import Testimonial from "./component/Testimonial/Testimonial"
import Blog from "./component/Blog/Blog"
import Contact from "./component/Contact/Contact"
import Contact2 from "./component/Contact/Contact2"
import Footer from "./component/Footer"
import "./App.css"
import Videobg from "../src/video/video1.mp4"

const App = () => {
  return (
    <>
    <div className="Video1">
       <div>
        <video src={Videobg} autoPlay loop muted />

      </div>
      <div className="body">
        <Header />
        <Home />
        {/* <Features /> */}
        <Portfolio />
        <Resume />
        <Testimonial />
        {/* <Blog /> */}
        <Contact />
        {/* <Contact2/> */}
        <Footer />
        
        
      </div>
    </div>
     

    </>
  )
}

export default App
